module.exports = __webpack_public_path__ + "img/kamer2.19b75d63.jpg";